import { render, staticRenderFns } from "./StudentService.vue?vue&type=template&id=594e6d56&scoped=true&lang=pug&"
import script from "./StudentService.vue?vue&type=script&lang=ts&"
export * from "./StudentService.vue?vue&type=script&lang=ts&"
import style0 from "./StudentService.vue?vue&type=style&index=0&id=594e6d56&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e6d56",
  null
  
)

export default component.exports